import { Button, Stack, Typography } from "@mui/material";
import { Link } from "react-router";
import { useNotificationContext } from "../../../shared/contexts/NotificationContext";
import ReportingIcon from "../../icons/ReportingIcon";

const RedirectToAdminPortal = ({ url }: { url: string }) => {
  const { sendNotification } = useNotificationContext();
  return (
    <Stack alignItems="center" justifyContent="center" height="100%" flex={1} flexDirection="column" gap={2}>
      <ReportingIcon sx={{ width: 160, height: 160 }} />
      <Typography variant="h6" sx={{ pt: 2 }}>
        Entrilia SmartViews is now in the Entrilia Admin Portal!
      </Typography>
      <Typography>
        You can now find this report in the Entrilia Admin Portal. Current page will be removed on 1st of November 2025.
      </Typography>
      <Stack direction="row" gap={1}>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => {
            navigator.clipboard.writeText(url);
            sendNotification("Link copied to clipboard");
          }}
        >
          Copy new link
        </Button>
        <Button component={Link} variant="contained" color="primary" to={url}>
          Open the report in the Admin Portal
        </Button>
      </Stack>
    </Stack>
  );
};

export default RedirectToAdminPortal;
